// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"d3aad9ca","103":"0c8b3583","142":"608a1afd","475":"9340ba19","813":"3a23ca2f"}[chunkId] + ".chunk.js";
};